import React from 'react';
import '../styles/AdBreakModal.css';

/**
 * Branded ad break modal — purely presentational.
 * All orchestration logic lives in useAdBreakFlow.
 */
const AdBreakModal = ({ open, onContinue, onMaybeLater }) => {
  if (!open) return null;

  return (
    <div className="ad-break-overlay" role="dialog" aria-modal="true" aria-label="Ad Break">
      <div className="ad-break-card">
        <p className="ad-break-label">Short Break</p>
        <h2 className="ad-break-title">Take a short break</h2>
        <p className="ad-break-message">
          This quick sponsored break helps keep PocketVideoke free.
        </p>

        <div className="ad-break-actions">
          <button className="ad-break-continue-btn" onClick={onContinue}>
            Continue
          </button>
          <button className="ad-break-later-btn" onClick={onMaybeLater}>
            Maybe later
          </button>
        </div>

        <p className="ad-break-upgrade">
          ✨ <a href="/pricing">Upgrade</a> to skip ads
        </p>
      </div>
    </div>
  );
};

export default AdBreakModal;
